export default "__VITE_ASSET__DRDvoWFd__"